import { render, staticRenderFns } from "./ManageEvent.vue?vue&type=template&id=2c0abe1e&scoped=true"
import script from "./ManageEvent.vue?vue&type=script&lang=js"
export * from "./ManageEvent.vue?vue&type=script&lang=js"
import style0 from "./ManageEvent.vue?vue&type=style&index=0&id=2c0abe1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0abe1e",
  null
  
)

export default component.exports